import React from 'react';
import 'whatwg-fetch';

import bookIcon from 'src/images/icons/003-book.svg';
import withAuth from 'src/hoc/withAuth';

const apiSearchBar = '/api/searchBar/';
const apiCustomerShow = '/api/customer/show/';

const oriState = {
  currQuery: '',
  dataContact: undefined,
  showList: true,
  contactSelectedId: undefined,
  researchClicked: false,
};

class ModalExistingContact extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.refreshResults = this.refreshResults.bind(this);
    this.linkToCustomer = this.linkToCustomer.bind(this);
    this.close = this.close.bind(this);
    this.reset = this.reset.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
  }

  handleClick(param) {
    this.setState({
      currQuery: param.name + ' ' + param.lastname,
      showList: false,
      contactSelectedId: param.id,
      researchClicked: true,
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit() {
    if (this.state.contactSelectedId === this.props.entityAssociated.id) {
      this.props.openToast(false, 'Impossible de lier le compte à lui même');
    } else {
      this.linkToCustomer(this.state.contactSelectedId, this.props.entityAssociated.id);
    }

    this.close();
  }

  componentDidUpdate(prevProps, prevState) {
    // after input update

    if (!this.state.researchClicked && this.state.currQuery != '' && prevState.currQuery != this.state.currQuery) {
      this.refreshResults(this.state.currQuery);
      this.setState({
        showList: true,
      });
    }

    if (prevState.researchClicked === true) {
      this.setState({
        researchClicked: false,
      });
    }

    return true;
  }

  refreshResults(currQuery) {
    let queryURL = apiSearchBar;
    let graphQL =
      '{ customers(search: "' +
      currQuery +
      '" ){ id, installationSite{ socialReason } }, contacts(search: "' +
      currQuery +
      '" ){ id, name, lastname }, employees(search: "' +
      currQuery +
      '" ){ id, firstname, lastname, user{ id, username } } }';
    queryURL += encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            dataContact: data['data']['contacts'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch search contacts: \n' + error);
        }.bind(this)
      );
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataContact } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content modal-link'>
            <div className='modal-header'>
              <h4 className='modal-title'>Ajouter au compte</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              <input
                ref='searchInput'
                name='currQuery'
                value={this.state.currQuery}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Recherche contact'
              />
              {this.state.currQuery != '' && this.state.showList && (
                <ul id='listSearchResult'>
                  {!dataContact && <span>Chargement...</span>}
                  {dataContact && dataContact.length == 0 && <span>Aucun résultat</span>}

                  {dataContact ? ( // list the contact results
                    dataContact.map((data, i) => (
                      <li onClick={this.handleClick.bind(this, data)}>
                        <img className='imgSearchResult' src={bookIcon} />
                        <span>{data.name + ' ' + data.lastname}</span>
                      </li>
                    ))
                  ) : (
                    <span></span>
                  )}
                </ul>
              )}
            </div>
            <div className='modal-actions'>
              <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                Annuler
              </button>
              <button onClick={this.handleSubmit} type='button' className='btn-link modal-action' data-dismiss='modal'>
                <strong>Ajouter</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  linkToCustomer(externalContactId, customerId) {
    let graphQL =
      'mutation { customer(id:' + customerId + ' externalContactId:' + externalContactId + '){externalContacts{ id }}}';

    let queryURL = apiCustomerShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['customer']['externalContacts']) {
            this.props.openToast(true, 'Le contact à bien été ajouté.');
            this.props.onLinkResult();
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
        }.bind(this)
      )
      .catch(
        function () {
          console.log('erreur fetch UPDATE customer entity');
        }.bind(this)
      );
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalExistingContact);
